import Theme from '@/Theme';

import '@mantine/core/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/nprogress/styles.css';
import '@mantine/dropzone/styles.css';

import './RootLayout.css';
import './theme-tokens.css';
// Imported after Mantine's stylesheet so the overlay rules win on equal specificity.
import './safe-area.css';
import './native.css';

import { Outlet, useLocation } from 'react-router';
import { Suspense, useEffect } from 'react';
import RouteFallback from '@/components/loaders/RouteFallback';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { AuthInterceptor } from '@/auth/AuthInterceptor';
import { BiometricLockScreen } from '@/auth/biometric/BiometricLockScreen';
import { UpdateGate } from '@/appUpdate/UpdateGate';
import { trackPageView } from '@/analytics/gtag';
import { hideSplashScreen } from '@/utils/splashScreen';

const RootLayout = () => {
	const location = useLocation();

	// Key on pathname only (not the whole location object) so query-param
	// changes — nuqs filter state and the like — do not fire spurious
	// page_views. The initial mount run covers first load
	// (initAnalytics sends with send_page_view:false).
	useEffect(() => {
		trackPageView();
	}, [location.pathname]);

	// The lazy routes below suspend on a spinner over the same background, which is a smoother
	// hand-off than holding the splash through every chunk and query.
	useEffect(() => {
		hideSplashScreen();
	}, []);

	return (
		<Theme>
			<NuqsAdapter>
				<AuthInterceptor />
				<BiometricLockScreen />
				<UpdateGate />
				<Suspense fallback={<RouteFallback />}>
					<Outlet />
				</Suspense>
			</NuqsAdapter>
		</Theme>
	);
};

export default RootLayout;
